import { Skeleton } from './Skeleton';
import { SkeletonFields } from './SkeletonFields';
import { SkeletonRegion } from './SkeletonRegion';

interface FormCardSkeletonProps {
  label: string;
  fields?: number;
}

/** A settings card (icon, heading, stacked fields, save button) before its values load — the company settings shape. */
export function FormCardSkeleton({ label, fields = 6 }: FormCardSkeletonProps) {
  return (
    <SkeletonRegion label={label} className="max-w-2xl rounded-lg border border-line bg-surface p-6">
      <div className="mb-6 flex items-center gap-3">
        <Skeleton className="size-9 rounded-lg" />
        <Skeleton className="h-5 w-44" />
      </div>
      <SkeletonFields count={fields} />
      <Skeleton className="mt-8 h-8 w-32" />
    </SkeletonRegion>
  );
}
